type ReportedEvent = {
  exception?: { values?: Array<{ mechanism?: { handled?: boolean } }> };
};

/**
 * `beforeSend` that drops an UNHANDLED event whose original value the user was
 * already shown (MYFITWORLD-V2-34 / V2-70).
 *
 * A `mutateAsync` that nobody awaits rejects with the same `BaseApiResponseError`
 * `AuthProvider` just toasted; the SDK files it as "Object captured as promise
 * rejection with keys: [object has no keys]" — its fields are private — and the
 * issue says nothing a toast had not already said. The Dialog owned this for its
 * own confirms; every other call site (a chip's remove button, a menu item, a
 * form Save) reaches here, so this is the one place that covers them all.
 *
 * Only unhandled events: an explicit `captureException` of the same error is a
 * decision someone made, and it stays.
 */
export function dropAnsweredRejections(
  wasAnswered: (error: unknown) => boolean,
) {
  return <TEvent extends ReportedEvent>(
    event: TEvent,
    hint: { originalException?: unknown },
  ) => {
    const isUnhandled = event.exception?.values?.some(
      (value) => value.mechanism?.handled === false,
    );
    return isUnhandled && wasAnswered(hint.originalException) ? null : event;
  };
}
